import { Checkbox } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../translations';
import { AvailabilityFormController } from '../../common.types';

type SendToPatientPortalProps = {
   readonly register: AvailabilityFormController['register'];
   readonly trigger: AvailabilityFormController['trigger'];
};

export const SendToPatientPortal = (props: SendToPatientPortalProps): JSX.Element | null => {
   return (
      <Checkbox
         testId={'sendToPatientPortal'}
         controller={props.register('sendToPatientPortal')}
         label={personnelTranslationKeys.sendToPatientPortal}
         onSelectionChange={() => {
            props.trigger(['slotDurationFixed']);
         }}
      />
   );
};
